import { Box } from '@chakra-ui/react';
import React from 'react';

interface GlassProps {
  className?: string;
  display?: object;
  onClick?: () => void;
}

const Glass: React.FC<GlassProps> = ({
  children,
  className,
  display,
  onClick,
}) => {
  return (
    <Box
      className={className}
      display={display}
      position="fixed"
      top="0"
      right="0"
      bottom="0"
      left="0"
      zIndex={10}
      background="rgba(0, 20, 48, 0.9)"
      onClick={onClick}
    >
      {children}
    </Box>
  );
};

export default Glass;
